import { Injectable, EventEmitter } from '@angular/core';
import { WindowSize } from '../models/windowSize.model';

@Injectable({
  providedIn: 'root',
})
export class OnresizeService {
  windowResized$: EventEmitter<WindowSize> = new EventEmitter<WindowSize>();

  constructor() {
    window.onresize = () => {
      document.documentElement.style.setProperty(
        '--document-height',
        document.documentElement.clientHeight.toString() + 'px'
      );
      this.windowResized$.emit({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      });
    };
  }
}
